import {useDispatch} from 'react-redux';

import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums';

import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {EPOCH_TERMS, EPOCH, ALIAS_TO_COMPETITION_ID} from '@constants';

import loadSEO from '@helpers/loadSEO';
import {CompetitionBanner, EpochTerms} from '@components/Competition';

import {metaInfo} from '@configs';
import {getConfigByApp} from '@utils';
import {BaseContext} from 'next/dist/shared/utils';
import {competitionService} from '@jobseeker/common-core/services';

type CompetitionTermsProps = {
  seoConfig: object;
};

const CompetitionTerms = ({seoConfig}: CompetitionTermsProps) => {
  const metaData = getConfigByApp(metaInfo, EPOCH, true, EPOCH_TERMS);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  return (
    <>
      <Interceptor metaInfo={metaData}>
        <SeoLayout seoConfig={seoConfig} paginationEnabled={true} />
        <NavLayout page={EPOCH}>
          <ResponsiveLayout
            variant={VersionVariants.VERSION_TWO}
            breadcrumbElements={[]}
          >
            <CompetitionBanner />
            <EpochTerms />
          </ResponsiveLayout>
        </NavLayout>
      </Interceptor>
    </>
  );
};

export const getServerSideProps = wrapper.getStaticProps(
  store => async (context: BaseContext) => {
    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: EPOCH_TERMS},
    });
    const alias = (context.query.alias as string) || 'epoch';

    const competitionId = ALIAS_TO_COMPETITION_ID[alias];

    const timelineInfo = await competitionService.fetchTimelineData(
      competitionId
    );
    const competitionName = timelineInfo?.config?.competitionName;
    const seoConfig = await loadSEO(`${competitionName}-terms`);

    if (
      timelineInfo?.registration &&
      Object.keys(timelineInfo?.registration).length > 0
    ) {
      store.dispatch({
        type: 'Competition/set_timeline_data',
        payload: {competition: timelineInfo},
      });
    }

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default CompetitionTerms;
